// extracted by mini-css-extract-plugin
module.exports = {"title":"Amount_title__1exLq","numericValue":"Amount_numericValue__6voUc","amount":"Amount_amount__FLsss","leftTextAlign":"Amount_leftTextAlign__1gAT1","bold":"Amount_bold__3mxK9"};